import React from "react";

interface NavigationButtonProps {
  direction: "back" | "forward";
  onNavigate: () => void;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({ direction, onNavigate }) => (
  <button
    aria-label={direction === "back" ? "Go to previous image" : "Go to next image"}
    className="gallery-navigation-button"
    data-gallery-navigation-direction={direction}
    type="button"
    onClick={onNavigate}
  >
    <svg
      aria-hidden="true"
      role="presentation"
      viewBox="0 0 52 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M40.6,0c2.4,2.7,4.6,4.7,6.3,6.1s3.5,2.4,5,3.1v1.3c-1.8.9-3.6,2-5.3,3.4s-3.7,3.4-6.1,6.1h-2.1c1.7-3.7,3.5-6.6,5.4-8.6H0v-2.8h43.9c-1.4-1.8-2.4-3.1-2.9-4s-1.4-2.4-2.4-4.6h2.1Z" />
    </svg>
  </button>
);

export default NavigationButton;
